import React from "react"
import "./CameraLense.css"

interface Props {
    id?: string
}

function CameraLense(props: Props) {

    const id = props.id ? props.id : "camera-lense"

    return (
        <div className="CameraLense" id={id}>
            <div className="container">
                <div className="shutter">
                    <div className="lens-outer"></div>
                    <div className="lens"></div>
                    <div className="leaf a"></div>
                    <div className="leaf b"></div>
                    <div className="leaf c"></div>
                </div>
            </div>
        </div>
    )
}

export default CameraLense